import { render, staticRenderFns } from "./suggestionsListRequestedChanges.vue.html?vue&type=template&id=b94a0342&"
import script from "./suggestionsListRequestedChanges.ts?vue&type=script&lang=ts&"
export * from "./suggestionsListRequestedChanges.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports